import { getGlobalCssUrl } from '../Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createSearchBoxTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<style>
:host {
  display: block;
  position: relative;
  width: 100%;
}

.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.searchbox-container {
  position: relative;
  width: 100%;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.search-input {
  width: 100%;
}

.suggestions-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  list-style: none;
  margin: 0;
  padding: 0;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: none;
}

.suggestions-list.show {
  display: block;
}

.suggestion-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  color: #333;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item:hover,
.suggestion-item.highlighted {
  background-color: #f0f0f0;
}

.suggestion-item.highlighted {
  outline: 2px solid #007bff;
  outline-offset: -2px;
}

.loading-item {
  color: #666;
  font-style: italic;
  cursor: default !important;
}

.loading-item:hover {
  background-color: transparent !important;
}

.no-results {
  color: #666;
  font-style: italic;
  cursor: default !important;
  text-align: center;
}

.no-results:hover {
  background-color: transparent !important;
}
</style>
`
  return t;
}

const getTemplateSearchBoxStyles = () => createSearchBoxTemplate();
export { getTemplateSearchBoxStyles };